import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { loadEvents } from "../../../../api/events";
import { getDefaultImage } from '../../../../utils/eventUtils';
import { formatDateOnly, isSameCalendarDay } from '../../../../utils/dateUtils';
// Swiper slider imported
import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "swiper/swiper.min.css";



const RecentEvent = () => {
  const [events, setEvents] = useState([]);

  // install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation, EffectFade]);

  useEffect(() => {

    const loadRecentEvents = async () => {
      try {
        const { eventsData } = await loadEvents();
        console.log('Loaded events:', eventsData);
        setEvents(eventsData);
      } catch (error) {
        console.error('Failed to load events:', error);
      }
    };

    loadRecentEvents();
  }, []);

  function scrollTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  

  const recentEventSlider = {
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 24,
    loop: true,
    roundLengths: true,
    autoplay: {
      delay: 12000,
    },
    navigation: {
      nextEl: ".blog-next",
      prevEl: ".blog-prev",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      480: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  };
  
  const serverUrl = process.env.REACT_APP_SERVER_URL;

  return (
    <>
      {/* ===============  recent event start =============== */}

      { events && events.length > 0 && (
      <div className="recent-event-wrap mt-110">
        <div className="container">
          <h3>Autres évènements</h3>
          <div className="recent-event-slider swiper">
            <Swiper {...recentEventSlider} className="swiper-wrapper">
              {events.map((event) => (
                <SwiperSlide className="swiper-slide" key={event.id}>
                  <div className="event-card-md">
                    <div className="event-thumb">
                      <img src={getDefaultImage(event)} alt="Imgs" />
                      <div className="event-lavel">
                        <i className="bi bi-diagram-3" /> <span>{event.category}</span>
                      </div>
                    </div>
                    <div className="event-content">
                      <div className="event-info">
                        <div className="event-date">
                          <Link onClick={scrollTop} to={"#"}>
                            {" "}
                            <i className="bi bi-calendar2-week" />
                            {event.endDate
                              ? (
                                  isSameCalendarDay(event.date, event.endDate)
                                    ? formatDateOnly(event.date)
                                    : `Du ${formatDateOnly(event.date)} au ${formatDateOnly(event.endDate)}`
                                )
                              : formatDateOnly(event.date)
                            }
                          </Link>
                        </div>
                        <div className="event-location">
                          <Link onClick={scrollTop} to={"#"}>
                            {" "}
                            <i className="bi bi-geo-alt" />
                            {event.location.postalCode ? `${event.location.cityName} (${event.location.postalCode})`: event.location.cityName}
                          </Link>
                        </div>
                      </div>
                      <h5 className="event-title">
                        <Link
                          onClick={scrollTop}
                          to={`${process.env.PUBLIC_URL}/event-details`}
                        >
                          {event.title.substring(0, 36)}
                        </Link>
                      </h5>
                      <div className="event-bottom">
                        <div className="event-readme">
                          <Link
                            onClick={scrollTop}
                            to={`${process.env.PUBLIC_URL}/event-details?eid=${event.id}`}
                          >
                            Détails
                          </Link>
                        </div>
                        <div className="event-share-icons">
                          <ul className="share-options">
                            <li>
                              <a href={`https://www.facebook.com/sharer/sharer.php?u=${serverUrl}/event-details?eid=${event.id}`} target="_blank" rel="noreferrer">
                                <i className="fab fa-facebook-f" />
                              </a>
                            </li>
                            <li>
                              <a href={`https://www.instagram.com/?url=${serverUrl}/event-details?eid=${event.id}`} target="_blank" rel="noreferrer">
                                <i className="fab fa-instagram" />
                              </a>
                            </li>
                            <li>
                              <a href={`https://twitter.com/intent/tweet?url=${serverUrl}/event-details?eid=${event.id}&text=${event.title}`} target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-x-twitter" />
                              </a>
                            </li>
                          </ul>
                          <div className="share-btn">
                            <i className="bi bi-share" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        </div>
      )}
      {/* ===============  recent event end =============== */}
    </>
  );
};

export default RecentEvent;
